"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Back-navigation safety for the installed web app (Add to Home Screen).
 *
 * Standalone mode has no browser back button, so two guarantees:
 *
 *  1. Sub-view back buttons marked with `data-app-back` prefer
 *     history.back() when the app has same-origin history, so "Volver"
 *     returns to the exact screen the user came from (Boletín opened from
 *     Perfil goes back to Perfil, not home). The anchor's href stays as the
 *     fallback for direct loads (no history, e.g. a home-screen launch that
 *     starts on a sub-view). Back links with FIXED semantics ("Volver al
 *     curso", "Volver a Hábitos") intentionally don't carry the attribute.
 *
 *  2. Pages outside the app chrome (classic theme: a page linked from an
 *     aviso, a 404) are dead ends in standalone — no bottom nav, no browser
 *     UI. There, inject a floating "Volver" pill (history.back(), href
 *     fallback to the app home). Never shown in a regular browser tab or on
 *     app surfaces, which have their own chrome.
 */
class AppBack {
    init() {
        this.enhanceBackLinks();
        this.addStandaloneFallback();
    }
    isStandalone() {
        return (window.matchMedia('(display-mode: standalone)').matches ||
            window.navigator.standalone === true);
    }
    hasInAppHistory() {
        return (window.history.length > 1 &&
            document.referrer.indexOf(window.location.origin) === 0);
    }
    enhanceBackLinks() {
        document.querySelectorAll('a[data-app-back]').forEach((el) => {
            el.addEventListener('click', (event) => {
                if (this.hasInAppHistory()) {
                    event.preventDefault();
                    window.history.back();
                }
            });
        });
    }
    addStandaloneFallback() {
        if (!this.isStandalone() || document.body.classList.contains('prepain-app')) {
            return;
        }
        const pill = document.createElement('a');
        pill.href = '/';
        pill.textContent = '‹ Volver';
        pill.setAttribute('aria-label', 'Volver');
        // Inline styles on purpose: this renders on classic-theme pages, outside
        // the .prepain-app scope every app SCSS rule is confined to.
        pill.style.cssText = [
            'position:fixed',
            'left:16px',
            'bottom:calc(16px + env(safe-area-inset-bottom))',
            'z-index:9999',
            'background:#fff',
            'color:#1a1a1a',
            'border:2px solid #e5e7eb',
            'border-radius:9999px',
            'padding:10px 18px',
            'font-weight:700',
            'font-size:14px',
            'line-height:1',
            'text-decoration:none',
            'box-shadow:0 2px 8px rgba(0,0,0,.12)',
        ].join(';');
        pill.addEventListener('click', (event) => {
            if (this.hasInAppHistory()) {
                event.preventDefault();
                window.history.back();
            }
        });
        document.body.appendChild(pill);
    }
}
exports.default = AppBack;
